const translations = {
    tryAgain: 'Try Again'
};

export default translations;
